import React, { Component } from 'react';
import { toast } from 'react-toastify';
import moment from 'moment';

//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { faPlus } from '@fortawesome/free-solid-svg-icons'

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


import fetchtest from '../api/index.js';
import Box from '../components/ui/Box.js';

import SelectInterface from '../components/forms/SelectInterface.js';
import EditMap from '../components/forms/MapTableEditForm.js';
import ManagedDistanceInput from '../components/forms/ManagedDistanceInput.js';
import MapInterface from '../components/forms/MapTableInterface.js';
import InputWrapper from '../components/forms/InputWrapper.js';
import PieceRateInput from '../components/forms/PieceRateInput.js';

class Page extends Component {
	constructor(props) {
		super(props);
		this.state = {
			startDate: new Date(),
			results: false,
			highlight_mode: "fortnightly",
			convertDate: moment().endOf('year').toDate(), //new Date(),
			prtext: "2x200,$130,3 x $100\n 4*10"
		};
		this.prime = "hello";
		this.fetcher = this.fetcher.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.selectChange = this.selectChange.bind(this);
		
		this.onEditSubmit = this.onEditSubmit.bind(this);
		
	}
	
	async handleChange(date) {
		this.setState({
			startDate: date
		});
		//console.log(date.toString());
		const d = date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate(); //toISOString().slice(0,10);
		try {
			let r = await fetchtest.get('/tests/payperiod/' + d);
			this.setState({results: r});
		} catch(e) {
			fetchtest.handleExceptions(e);
		}
		
	}
	
	handleConvertDateChange = (date) => {
		console.log(date);
		this.setState({
			convertDate: date
		});
	}
	
	handlePRChange = (text) => {
		this.setState({
			prtext: text
		});
	}
	
	selectChange(e) {
		this.setState({highlight_mode: e.target.value});
	}
	async fetcher(url) {
			try {
				let r = await fetchtest.get('tests/fetchtest/' + url);
				toast.success(r);
			} catch(e) {
				fetchtest.handleExceptions(e);
			};
	}
	
	componentDidMount() {
		this.handleChange(this.state.startDate);
		this.checkCrops();
	}
	
	async checkCrops() {
		try {
			let r = await fetchtest.get('crops/');
			console.log(r);
		} catch(e) {
			fetchtest.handleExceptions(e);
		}
	}
	
	
	async onEditSubmit(selectValue, formValue) {
		console.log("onEditSubmit", selectValue, formValue);
		try {
			await fetchtest.get('tests/fetchtest/error');
			return true;
		} catch(e) {
			fetchtest.handleExceptions(e);
		}
		return false;
	}
	
	render() {
		let highlight = [];
		let o = '';
		if (this.state.results) {
			o = <div>
				<h2>Fortnightly</h2>
				<p>This period begins on <strong>{this.state.results.fortnightly.start}</strong> and ends on <strong>{this.state.results.fortnightly.end}</strong>.</p>
				<p><small>The known pay period start date is  <strong>{this.state.results.fortnightly.value}</strong></small></p>
				<h2>Days of month</h2>
				<p>This period begins on <strong>{this.state.results.dates.start}</strong> and ends on <strong>{this.state.results.dates.end}</strong>.</p>
				<p><small>The pay period dates are <strong>{JSON.stringify(this.state.results.dates.value)}</strong></small></p>
			</div>;
			
			// Highlights
			const range = this.state.results[this.state.highlight_mode];
			let start = moment(range.start);
			const end = moment(range.end);
			for (; start <= end;) {
				start=start.add(1, 'days');
				let d = new Date(start.format("X")*1000);
				let d2 = new Date(d.getTime() + d.getTimezoneOffset()*-60000);
				highlight.push(d2);
			}
		}
		
		let options = [
			{value: "one", label: "One"},
			{value: "two", label: "Two"},
			{value: "three", label: "Three"},
			{value: "four", label: "Four"},
			{value: "five", label: "Five"},
		];
		
		return <div className="Test page">
				<h1>Test page</h1>
				<Box 
					title="Fetch tests"
				>
					<button className="block" onClick={this.fetcher.bind(this, '')} >Successful request</button>
					<button className="block" onClick={this.fetcher.bind(this, 'error')}>HTTP error</button>
					<button className="block" onClick={this.fetcher.bind(this, 'invalid')} >Invalid JSON</button>
					<button className="block" onClick={this.fetcher.bind(this, 'error/401')}>Specific HTTP error</button>
					<button className="block" onClick={this.fetcher.bind(this, 'exception')}>Exception</button>
				</Box>
				<Box title="Pay period test">
					<label><strong>Needle date </strong></label> 
					<DatePicker
						selected={this.state.startDate}
						onChange={this.handleChange}
						highlightDates={highlight}
					/>
					<label> Highlight mode </label>
					<select name="highlight_mode" style={{display: "inline-block", width: "auto"}} value={this.state.highlight_mode} onChange={this.selectChange}>
						<option value="fortnightly">Fortnightly</option>
						<option value="dates">Days of month</option>
					</select>
					{o}
				</Box>
				<Box title="Select interface test" >
					<SelectInterface 
						options={options} 
						placeholder="Select an option.." 
						value={options[2]} 
						type="test value" 
						editForm={EditMap}
						addForm={(props) => (<p>add form</p>)}
						onEditSubmit={this.onEditSubmit}
					/>
				</Box>
				<Box title="Distance input test" >
					<ManagedDistanceInput 
						placeholder="Distance" 
						value={20}
						name="fakeDistance" 
						onChange={(e)=>{console.log(e.target.name, e.target.value);}}
					/>
				</Box>
				<Box title="Simple map interface test" >
					<MapInterface 
						maptable="Crop"
					/>
				</Box>
				<Box title="Complex map interface test" >
					<MapInterface 
						maptable="Varieties"
						parents={["Crop"]}
						groupby="Crop"
					/>
				</Box>
				<Box title="Input wrapper test" >
					<InputWrapper label="This is a text field" description="Just a text field." info="You can type text.  That is all." id="textfield">
						<input type="text" />
					</InputWrapper>
				</Box>
				<Box title="Date conversion test" >
					<DatePicker
						selected={this.state.convertDate}
						onChange={this.handleConvertDateChange}
					/> {this.state.convertDate.api()}
				</Box>
				<Box title="Piecerate interface test" >
					<PieceRateInput
						text={this.state.prtext}
						onChange={this.handlePRChange} 
					/>
				</Box>

			</div>;
	}
}

export default Page;